function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';
import { isPlatform } from '@/utils/settingMer';
var productPrefix = isPlatform ? '/admin/platform/product' : '/admin/business/product';

/**
 * 新增商品
 * @param data
 */
export function productCreateApi(data) {
  return request({
    url: "".concat(productPrefix, "/save"),
    method: 'post',
    data: data
  });
}

/**
 * 完整编辑商品
 * @param data
 */
export function productFullUpdateApi(data) {
  return request({
    url: isPlatform ? "".concat(productPrefix, "/full/update") : "".concat(productPrefix, "/update"),
    method: 'post',
    data: data
  });
}

/**
 * 商品详情
 * @param pram
 */
export function productDetailApi(id) {
  return request({
    url: "".concat(productPrefix, "/info/").concat(id),
    method: 'GET'
  });
}

/**
 * 删除商品
 * @param pram
 */
export function productDeleteApi(id, type) {
  if (isPlatform) {
    return request({
      url: "".concat(productPrefix, "/delete"),
      method: 'post',
      data: {
        id: id,
        type: type
      }
    });
  }
  return request({
    url: "".concat(productPrefix, "/delete/").concat(id),
    method: 'get',
    params: {
      type: type
    }
  });
}

/**
 * 恢复商品
 * @param id 商品ID
 */
export function productRestoreApi(id) {
  return request({
    url: isPlatform ? "".concat(productPrefix, "/restore/").concat(id) : "".concat(productPrefix, "/restore/").concat(id),
    method: 'post'
  });
}

/**
 * 商品列表 表头数量
 */
export function productHeadersApi(params) {
  return request({
    url: "".concat(productPrefix, "/tabs/headers"),
    method: 'GET',
    params: params
  });
}

/**
 * 商品列表
 * @param pram
 */
export function productLstApi(params) {
  return request({
    url: "".concat(productPrefix, "/list"),
    method: 'GET',
    params: params
  });
}

/**
 * 商户主体商品列表可选店铺
 */
export function businessProductStoreOptionsApi(params) {
  return request({
    url: '/admin/business/product/store/options',
    method: 'GET',
    params: params
  });
}

/**
 * 商品审核
 * @param pram
 */
export function productAuditApi(data) {
  return request({
    url: "".concat(productPrefix, "/audit"),
    method: 'post',
    data: data
  });
}

/**
 * 修改虚拟销量
 * @param pram
 */
export function onChangeSalesApi(data) {
  return request({
    url: "".concat(productPrefix, "/virtual/sales"),
    method: 'post',
    data: data
  });
}

/**
 * 商品分类 分类缓存树
 * @param pram
 */
export function productCategoryApi() {
  return request({
    url: "".concat(productPrefix, "/category/cache/tree"),
    method: 'GET'
  });
}
/**
 * 商品分类 列表
 * @param pram
 */
export function productCategoryListApi(params) {
  return request({
    url: "".concat(productPrefix, "/category/list"),
    method: 'GET',
    params: params
  });
}
/**
 * 商品分类 新增
 * @param pram
 */
export function productCategoryAddApi(data) {
  return request({
    url: "".concat(productPrefix, "/category/add"),
    method: 'post',
    data: data
  });
}
/**
 * 商品分类 编辑
 * @param pram
 */
export function productCategoryUpdateApi(data) {
  return request({
    url: "".concat(productPrefix, "/category/update"),
    method: 'post',
    data: data
  });
}
/**
 * 商品分类 删除
 * @param pram
 */
export function productCategoryDeleteApi(id) {
  return request({
    url: "".concat(productPrefix, "/category/delete/").concat(id),
    method: 'post'
  });
}
/**
 * 商品分类 修改分类显示状态
 * @param pram
 */
export function productCategoryShowApi(id) {
  return request({
    url: "".concat(productPrefix, "/category/update/show/").concat(id),
    method: 'post'
  });
}

/**
 * 商品上架
 * @param pram
 */
export function putOnShellApi(id) {
  return request({
    url: "".concat(productPrefix, "/up/").concat(id),
    method: 'post'
  });
}
/**
 * 商品强制下架
 * @param pram
 */
export function offShellApi(data) {
  var id = data && _typeof(data) === 'object' ? data.id || data.ids : data;
  return request({
    url: isPlatform ? "/admin/platform/product/force/down" : "".concat(productPrefix, "/down/").concat(id),
    method: 'post',
    data: isPlatform ? data : undefined
  });
}

/**
 * 商品评论 列表
 * @param pram
 */
export function replyListApi(params) {
  return request({
    url: "".concat(productPrefix, "/reply/list"),
    method: 'GET',
    params: params
  });
}
/**
 * 商品评论 新增
 * @param pram
 */
export function replyCreatApi(data) {
  return request({
    url: isPlatform ? '/admin/store/product/reply/save' : "".concat(productPrefix, "/reply/virtual"),
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 编辑
 * @param pram
 */
export function replyEditApi(data) {
  return request({
    url: isPlatform ? '/admin/store/product/reply/update' : "".concat(productPrefix, "/reply/update"),
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 详情
 * @param pram
 */
export function replyInfoApi(id) {
  return request({
    url: isPlatform ? "/admin/store/product/reply/info/".concat(id) : "".concat(productPrefix, "/reply/info/").concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 删除
 * @param pram
 */
export function replyDeleteApi(id) {
  return request({
    url: "".concat(productPrefix, "/reply/delete/").concat(id),
    method: isPlatform ? 'GET' : 'post'
  });
}

/**
 * 商品评论 导出
 * @param pram
 */
export function productExportApi(params) {
  return request({
    url: "/admin/export/excel/product",
    method: 'get',
    params: params
  });
}

/**
 * 商品复制 99Api
 * @param pram
 */
export function importProductApi(params) {
  return request({
    url: isPlatform ? "/admin/store/product/importProduct" : "".concat(productPrefix, "/importProduct"),
    method: 'post',
    params: params
  });
}

/**
 * 商品复制 一号通
 * @param pram
 */
export function copyProductApi(data) {
  return request({
    url: isPlatform ? "/admin/store/product/copy/product" : "".concat(productPrefix, "/copy/product"),
    method: 'post',
    data: data
  });
}

/**
 * 商品列表 导出
 * @param pram
 */
export function productExcelApi(params) {
  return request({
    url: isPlatform ? "/admin/export/excel/product" : "/admin/business/export/product/excel",
    method: 'get',
    params: params
  });
}

/**
 * 商品列表 获取复制商品配置
 * @param pram
 */
export function copyConfigApi() {
  return request({
    url: isPlatform ? "/admin/store/product/copy/config" : "".concat(productPrefix, "/copy/config"),
    method: 'post'
  });
}

/**
 * 订单数据 导出
 * @param pram
 */
export function orderExcelApi(params) {
  return request({
    url: isPlatform ? "/admin/export/excel/order" : "/admin/business/export/order/excel",
    method: 'get',
    params: params
  });
}

/**
 * 品牌 列表
 * @param pram
 */
export function brandListApi(params) {
  return request({
    url: "".concat(productPrefix, "/brand/list"),
    method: 'get',
    params: params
  });
}

/**
 * 品牌缓存列表(全部)
 * @param pram
 */
export function brandListAllApi() {
  return request({
    url: "".concat(productPrefix, "/brand/cache/list"),
    method: 'get'
  });
}

/**
 * 品牌 新增
 * @param pram
 */
export function brandAddApi(data) {
  return request({
    url: "".concat(productPrefix, "/brand/add"),
    method: 'post',
    data: data
  });
}

/**
 * 品牌 编辑
 * @param pram
 */
export function brandUpdateApi(data) {
  return request({
    url: "".concat(productPrefix, "/brand/update"),
    method: 'post',
    data: data
  });
}

/**
 * 品牌 删除
 * @param pram
 */
export function brandDeleteApi(id) {
  return request({
    url: "".concat(productPrefix, "/brand/delete/").concat(id),
    method: 'post'
  });
}

/**
 * 品牌 修改品牌显示状态
 * @param pram
 */
export function brandShowApi(id) {
  return request({
    url: "".concat(productPrefix, "/brand/update/show/").concat(id),
    method: 'post'
  });
}

/**
 * 保障服务 列表
 * @param pram
 */
export function guaranteeListApi(params) {
  return request({
    url: "".concat(productPrefix, "/guarantee/list"),
    method: 'get',
    params: params
  });
}

/**
 * 保障服务 新增
 * @param pram
 */
export function guaranteeAddApi(data) {
  return request({
    url: "".concat(productPrefix, "/guarantee/add"),
    method: 'post',
    data: data
  });
}

/**
 * 保障服务 编辑
 * @param pram
 */
export function guaranteeUpdateApi(data) {
  return request({
    url: isPlatform ? "/admin/platform/product/guarantee/update" : "/admin/business/product/guarantee/edit",
    method: 'post',
    data: data
  });
}

/**
 * 保障服务 删除
 * @param pram
 */
export function guaranteeDeleteApi(id) {
  return request({
    url: "".concat(productPrefix, "/guarantee/delete/").concat(id),
    method: 'post'
  });
}

/**
 * 保障服务 修改品牌显示状态
 * @param pram
 */
export function guaranteeShowApi(id) {
  return request({
    url: "".concat(productPrefix, "/guarantee/update/show/").concat(id),
    method: 'post'
  });
}

/**
 * 修改商品
 * @param pram
 */
export function updateProductApi(data) {
  return request({
    url: "".concat(productPrefix, "/update"),
    method: 'post',
    data: data
  });
}

// 商品单位 列表
export function productUnitListApi() {
  return request({
    url: isPlatform ? '/admin/platform/product/unit/list' : '/admin/merchant/product/unit/list',
    method: 'get'
  });
}

// 商品单位 新增
export function productUnitsaveApi(data) {
  return request({
    url: '/admin/merchant/product/unit/save',
    method: 'post',
    data: data
  });
}

/**
 * 商品可用优惠券列表
 * @param pram
 */
export function productCouponListApi() {
  return request({
    url: isPlatform ? '/admin/platform/coupon/product/usable/list' : '/admin/business/coupon/product/usable/list',
    method: 'get'
  });
}

/**
 * 商品规格 列表
 * @param params
 */
export function templateListApi(params) {
  return request({
    url: "".concat(productPrefix, "/rule/list"),
    method: 'get',
    params: params
  });
}

/**
 * 商品规格 删除
 * @param id
 */
export function attrDeleteApi(id) {
  return request({
    url: "".concat(productPrefix, "/rule/delete/").concat(id),
    method: 'post'
  });
}

/**
 * 商品规格 新增
 * @param data
 */
export function attrCreatApi(data) {
  return request({
    url: "".concat(productPrefix, "/rule/save"),
    method: 'post',
    data: data
  });
}

/**
 * 商品规格 编辑
 * @param data
 */
export function attrEditApi(data) {
  return request({
    url: "".concat(productPrefix, "/rule/save"),
    method: 'post',
    data: data
  });
}

/**
 * 商品规格 详情
 * @param id
 */
export function attrInfoApi(id) {
  return request({
    url: "".concat(productPrefix, "/rule/info/").concat(id),
    method: 'get'
  });
}

/**
 * 商品搜索分页列表（活动），diy中使用
 * @param pram
 */
export function productActivityListApi(params) {
  return request({
    url: "".concat(productPrefix, "/activity/search/page"),
    method: 'get',
    params: params
  });
}

/**
 * 根据商品id集合查询商品列表
 * @param pram
 */
export function productListbyidsApi(data) {
  return request({
    url: "".concat(productPrefix, "/listbyids"),
    method: 'post',
    data: data
  });
}

/**
 * 商品标签列表
 * @param params 查询参数
 * @returns {*} 查询结果
 */
export function productTagListApi(params) {
  return request({
    url: "admin/platform/producttag/list",
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      keywords: encodeURI(params.keywords)
    })
  });
}

/**
 * 商品标签删除
 * @param id 待删除id
 * @returns {*}
 */
export function productTagDelete(id) {
  return request({
    url: "/admin/platform/producttag/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 商品标签详情
 * @param id
 * @returns {*}
 */
export function productTagInfoApi(id) {
  return request({
    url: "/admin/platform/producttag/info/".concat(id),
    method: 'get'
  });
}

/**
 * 新增商品标签
 * @param data 待新增数据
 * @returns {*} 新增结果
 */
export function productTagAddApi(data) {
  return request({
    url: "admin/platform/producttag/save",
    method: 'post',
    data: data
  });
}

/**
 * 编辑商品标签
 * @param data 待编辑数据
 * @returns {*} 新增结果
 */
export function productTagUpdateApi(data) {
  return request({
    url: "admin/platform/producttag/update",
    method: 'post',
    data: data
  });
}

/**
 * 更新标签状态
 * @param id 标签id
 * @param status 标签状态
 * @returns {*}
 */
export function productTagStatusApi(id, status) {
  return request({
    url: "/admin/platform/producttag/status/".concat(id, "/").concat(status),
    method: 'get'
  });
}

/**
 * 平台端批量商品审核
 * @returns {*}
 */
export function productBatchAuditApi(data) {
  return request({
    url: "".concat(productPrefix, "/batch/audit"),
    method: 'post',
    data: data
  });
}

/**
 * 批量设置虚拟销量
 * @returns {*}
 */
export function productBatchVirtualSalesApi(data) {
  return request({
    url: "".concat(productPrefix, "/batch/set/virtual/sales"),
    method: 'post',
    data: data
  });
}

/**
 * 商品搜索分页列表（营销）
 * @param pram
 */
export function productMarketingListApi(params) {
  return request({
    url: "".concat(productPrefix, "/marketing/search/page"),
    method: 'get',
    params: params
  });
}